import React, { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { occupancyColor } from "./common";

/* Phase 200 — Leaflet map of parking locations; marker colour = occupancy (green < 70 %, amber < 90 %, red ≥ 90 %). */

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) { map.setView(points[0], 14); return; }
    map.fitBounds(points, { padding: [30, 30], maxZoom: 15 });
  }, [map, JSON.stringify(points)]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export const LocationMap = ({ locations, selectedId, onSelect, height = 360, renderPopup, children }) => {
  const located = (locations || []).filter((l) => l.lat != null && l.lng != null);
  const pts = located.map((l) => [l.lat, l.lng]);
  const center = pts.length ? pts[0] : [20.2961, 85.8245];
  return (
    <div style={{ height }} className="relative isolate z-0 rounded-xl overflow-hidden border" data-testid="parking-location-map">
      <MapContainer center={center} zoom={12} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FitBounds points={pts} />
        {located.map((l) => {
          const pct = l.occupancy?.total?.occupancy_pct ?? 0;
          const sel = l.id === selectedId;
          return (
            <CircleMarker key={l.id} center={[l.lat, l.lng]} radius={sel ? 14 : 11}
              pathOptions={{ color: sel ? "#0c4a6e" : "#ffffff", weight: sel ? 3 : 2, fillColor: l.is_active === false ? "#94a3b8" : occupancyColor(pct), fillOpacity: 0.9 }}
              eventHandlers={{ click: () => onSelect && onSelect(l) }}>
              <Tooltip direction="top" offset={[0, -8]} opacity={0.95}>
                <span className="text-xs font-medium">{l.name}</span>
                <span className="text-xs"> · {l.occupancy?.total?.available ?? "—"} free</span>
              </Tooltip>
              {renderPopup && <Popup>{renderPopup(l)}</Popup>}
            </CircleMarker>
          );
        })}
        {children}
      </MapContainer>
    </div>
  );
};
